define('Components/Loyalty/js/views/blocks/CartDeliveryDataView',[
    'backbone',
    'underscore',
    'app',
    'template!Components/Loyalty/templates/blocks/cart-cagnottage',
],
function (
    Backbone,
    _,
    app,
    CartCagnottageTemplate
    ) {

        var parentView, cart, context;

    function getRatio(){
        return app.c('_RATIO_SWAP_PTS_AMOUNT_', 1) / 100;
    }

    function formatPoint(points){
        points = parseFloat(points);
        return app.t(points>1 ? '%s points':'%s point','Loyalty',points.toFixed(0));
    }

    return Backbone.View.extend({
        initialize:function(options){
            var view = this;
            cart = options.cart;
            if(!cart.getStore()) return; // si on a pas de boutique on ne fait rien
            context = options.context;
            parentView = options.view;
            view.listenTo(cart, 'change:total_price_ttc change:cagnotte', this.render);
            view.render();
        },

        render: function() {
            var cagnotteAmount = formatPoint((cart.getPriceTTC() - cart.getCagnotte()) * getRatio()),
                label = app.t(cart.isVAE() ? 'Grâce à cette commande vous allez cagnotter %s' :
                    'En Click & Collect, grâce à cette commande vous pouvez cagnotter %s', 'Cart', cagnotteAmount);
            this.$el.html(CartCagnottageTemplate({label:label}))
        },
    });
});
